/**
 * HelpContactPage — single concise card with QUOD-Tech contact details.
 * Text-only; no images. Provides a `mailto:` shortcut pre-filling a
 * support subject line.
 */
import React from 'react';
import AppHeader from '../layout/AppHeader';

export default function HelpContactPage() {
  return (
    <>
      <AppHeader active="help" />
      <div className="page-shell" data-testid="help-contact-page">
        <div className="qf-glass-panel" style={{ padding: 24, marginTop: 12, maxWidth: 560 }}>
          <h2 style={{ marginTop: 0, fontSize: 22, fontWeight: 700 }}>Contact QUOD-Tech</h2>
          <p style={{ fontSize: 13, color: 'var(--text-secondary)', marginTop: 4 }}>
            Support, account, and partnership questions. We aim to respond within
            one business day.
          </p>

          <div style={{ marginTop: 16, paddingTop: 12, borderTop: '1px solid var(--border)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0' }}>
              <span style={{ fontSize: 12, color: 'var(--text-secondary)' }}>Company</span>
              <span style={{ fontSize: 13, fontWeight: 600 }} data-testid="contact-company">QUOD-Tech Ltd</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0' }}>
              <span style={{ fontSize: 12, color: 'var(--text-secondary)' }}>Website</span>
              <a href="https://www.quod-tech.com" target="_blank" rel="noopener noreferrer"
                 style={{ fontSize: 13, fontWeight: 600 }} data-testid="contact-website">
                www.quod-tech.com
              </a>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0' }}>
              <span style={{ fontSize: 12, color: 'var(--text-secondary)' }}>Email</span>
              <a href="mailto:info@quod-tech.com?subject=QUOD-Finder%20Support"
                 style={{ fontSize: 13, fontWeight: 600 }} data-testid="contact-email">
                info@quod-tech.com
              </a>
            </div>
          </div>

          <div style={{ marginTop: 18 }}>
            <a className="btn btn-primary btn-sm"
               href="mailto:info@quod-tech.com?subject=QUOD-Finder%20Support"
               data-testid="contact-mail-button">
              Email QUOD-Tech support
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
